module.exports = __webpack_public_path__ + "assets/img/advantage1.64f04925.png";